window.initTextEditable = function (options) {
  var namespace = $('body').attr('id');
  var $target = options.target;
  var answerId = options.answerId;
  var questionId = options.questionId;
  var admin = options.admin;
  var userId = options.userId;
  var emptytext = options.emptytext;

  $target.editable({
    ajaxOptions: {
      type: answerId ? 'put' : 'post',
      dataType: 'json'
    },
    send: 'always',
    url: answerId ? putUrl(admin, answerId, userId) : postUrl(admin, userId),
    type: 'text',
    emptytext: emptytext,
    pk: answerId,
    highlight: false,
    params: function (params) {
      params.profile_answer = {content: params.value};
      params.question_id = questionId;
      return params;
    },
    success: function (data, config) {
      if (data && data.id) {  //record created, response like {"id": 2}
        //set pk
        $(this).editable('option', 'pk', data.id)
        .editable('option', 'url', putUrl(admin, data.id, userId))
        .editable('option', {
          ajaxOptions: {
            type: 'put',
            dataType: 'json'
          }
        });
      } else if (data && data.errors) {
        //server-side validation error, response like {"errors": {"username": "username already exist"} }
        config.error.call(this, data.errors);
      }
    },
    error: function (response, newValue) {
      if (response.status === 500) {
        return 'お手数おかけしますが、もう一度登録してください。';
      } else {
        return JSON.parse(response.responseText).message;
      }
    }
  });

  function postUrl(admin, userId) {
    return admin ? '/' + namespace + '/users/' + userId + '/profile_answers/' : '/users/' + userId + '/profile_answers/';
  }

  function putUrl(admin, answerId, userId) {
    return admin ? '/' + namespace + '/profile_answers/' + answerId : '/profile_answers/' + answerId;
  }
};
